import { useNavigate } from '@remix-run/react';
import { useEffect, useState } from 'react';
import { Slider } from '../Slider';

interface SlideFilterProps {
	min: number;
	max: number;
	active: boolean;
	urlGenerator: (value: number[]) => string;
}

export function SlideFilter({ min, max, active, urlGenerator }: SlideFilterProps) {
	const [minValue, setMinValue] = useState(min);
	const [maxValue, setMaxValue] = useState(max);
	const navigate = useNavigate();

	useEffect(() => {
		if (!active) {
			setMinValue(min);
			setMaxValue(max);
		}
	}, [active]);

	return (
		<div className="flex flex-col items-start">
			<p className="text-sm">
				${minValue} to ${maxValue}
			</p>
			<div className="my-6 w-full h-3 bg-grey/20 rounded-full relative">
				<Slider
					defaultValue={[min, max]}
					value={[minValue, maxValue]}
					min={min}
					max={max}
					step={0.1}
					ariaLabel={['Minimum Price', 'Maximum Price']}
					ariaValuetext={state => `Price ${state.valueNow}`}
					onChange={values => {
						setMinValue(values[0]);
						setMaxValue(values[1]);
					}}
					onAfterChange={values => {
						navigate(urlGenerator(values));
					}}
				/>
			</div>
		</div>
	);
}
